module.exports = __webpack_public_path__ + "static/media/server_error_page.6766deeb.svg";